/**
 * Maven — extras do carrinho
 *
 * Dois elementos, os dois desenhados para viverem dentro da gaveta do carrinho.
 * A gaveta e reescrita de raiz (innerHTML) sempre que o carrinho muda, por isso
 * nada aqui pode viver num <script> la dentro: sao *custom elements*, que o
 * navegador volta a ligar sozinho a cada nova pintura.
 *
 *   <mvn-cronometro>  contagem decrescente de 10 minutos
 *   <mvn-desconto>    barra de progresso ate aos descontos por valor
 */

/* ------------------------------------------------------------------ */
/* Cronometro                                                          */
/* ------------------------------------------------------------------ */
if (!customElements.get('mvn-cronometro')) {
  const CHAVE_FIM = 'mvnReservaFim';
  const CHAVE_ITENS = 'mvnReservaItens';

  class MvnCronometro extends HTMLElement {
    connectedCallback() {
      this.relogio = this.querySelector('[data-relogio]');
      this.frase = this.querySelector('[data-frase]');
      this.risco = this.querySelector('.mvn-cron__barra i');
      this.minutos = parseInt(this.dataset.minutos, 10) || 10;
      this.duracao = this.minutos * 60 * 1000;

      this.decideOFim();
      this.pinta();
      this.relogioInterno = setInterval(() => this.pinta(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.relogioInterno);
    }

    /*
     * Quando e que a contagem recomeca:
     *  - nao ha nada guardado;
     *  - entrou mais uma camisola no carrinho;
     *  - o prazo acabou ha mais de meia hora (quem volta amanha nao merece
     *    encontrar um cronometro parado a zero).
     */
    decideOFim() {
      const agora = Date.now();
      const itensAgora = parseInt(this.dataset.itens, 10) || 0;
      let fim = parseInt(localStorage.getItem(CHAVE_FIM), 10);
      const itensAntes = parseInt(localStorage.getItem(CHAVE_ITENS), 10) || 0;

      const recomeca =
        !fim ||
        isNaN(fim) ||
        itensAgora > itensAntes ||
        agora - fim > 30 * 60 * 1000;

      if (recomeca) {
        fim = agora + this.duracao;
        localStorage.setItem(CHAVE_FIM, String(fim));
      }
      localStorage.setItem(CHAVE_ITENS, String(itensAgora));
      this.fim = fim;
    }

    pinta() {
      const falta = this.fim - Date.now();

      if (falta <= 0) {
        this.classList.add('acabou');
        if (this.relogio) this.relogio.textContent = '00:00';
        if (this.frase && this.dataset.fraseFim) this.frase.textContent = this.dataset.fraseFim;
        if (this.risco) this.risco.style.width = '0%';
        clearInterval(this.relogioInterno);
        return;
      }

      const m = Math.floor(falta / 60000);
      const s = Math.floor((falta % 60000) / 1000);
      if (this.relogio) {
        this.relogio.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }
      if (this.risco) this.risco.style.width = (falta / this.duracao) * 100 + '%';
      /* Os ultimos dois minutos ficam vermelhos. */
      this.classList.toggle('urgente', falta < 2 * 60 * 1000);
    }
  }

  customElements.define('mvn-cronometro', MvnCronometro);
}

/* ------------------------------------------------------------------ */
/* Barra dos descontos por valor                                       */
/* ------------------------------------------------------------------ */
if (!customElements.get('mvn-desconto')) {
  /* Amarelo no principio, verde no fim. O tom anda com o progresso, por isso
     quando o cliente esta quase na primeira bola a barra ja esta esverdeada. */
  const TOM_INICIO = 46;
  const TOM_FIM = 122;

  const cor = (progresso, luz) =>
    'hsl(' + Math.round(TOM_INICIO + (TOM_FIM - TOM_INICIO) * progresso) + ',72%,' + luz + '%)';

  class MvnDesconto extends HTMLElement {
    connectedCallback() {
      /*
       * Os degraus vem em centimos da moeda da loja. A taxa do Shopify passa-os
       * para a moeda que o cliente esta a ver — sem isto, um cliente em dolares
       * via a barra a mentir-lhe. E o mesmo caminho que o tema ja usa nos
       * portes gratis.
       */
      const taxa = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      const total = parseInt(this.dataset.total, 10) || 0;
      const d1 = Math.round(parseInt(this.dataset.degrau1, 10) * taxa);
      const d2 = Math.round(parseInt(this.dataset.degrau2, 10) * taxa);

      const frase = this.querySelector('[data-frase]');
      const emoji = this.querySelector('[data-emoji]');
      const risco = this.querySelector('.mvn-desc__barra i');
      const bola1 = this.querySelector('[data-bola="1"]');
      const bola2 = this.querySelector('[data-bola="2"]');

      /* As legendas por baixo de cada bola: quanto e preciso, e quanto se ganha. */
      const legs = this.querySelectorAll('.mvn-desc__leg');
      if (legs[0]) {
        legs[0].querySelector('[data-valor]').textContent = this.dinheiro(d1);
        legs[0].querySelector('[data-pct]').textContent = this.dataset.pct1 || '';
      }
      if (legs[1]) {
        legs[1].querySelector('[data-valor]').textContent = this.dinheiro(d2);
        legs[1].querySelector('[data-pct]').textContent = this.dataset.pct2 || '';
      }

      /*
       * A primeira bola fica a meio da pista, a segunda no fim: metade da barra
       * para o primeiro degrau, metade para o segundo.
       */
      let porCento;
      let texto = '';
      let cara = '🎁';
      let nivel = 0;

      if (total < d1) {
        porCento = (total / d1) * 50;
        texto = this.montaFrase(this.dataset.fraseFalta1, d1 - total);
      } else if (total < d2) {
        nivel = 1;
        cara = '🎉';
        porCento = 50 + ((total - d1) / (d2 - d1)) * 50;
        texto = this.montaFrase(this.dataset.fraseFalta2, d2 - total);
      } else {
        nivel = 2;
        cara = '🔥';
        porCento = 100;
        texto = this.dataset.fraseMax || '';
      }

      const progresso = porCento / 100;
      const corAgora = cor(progresso, 40);

      if (frase) frase.textContent = texto;
      if (emoji) emoji.textContent = cara;
      this.dataset.nivel = String(nivel);
      this.style.setProperty('--mvn-cor', corAgora);

      if (risco) {
        risco.style.background = 'linear-gradient(90deg,' + cor(0, 52) + ' 0%,' + corAgora + ' 100%)';
      }
      if (bola1) bola1.classList.toggle('atingida', nivel >= 1);
      if (bola2) bola2.classList.toggle('atingida', nivel >= 2);
      if (legs[0]) legs[0].classList.toggle('atingida', nivel >= 1);
      if (legs[1]) legs[1].classList.toggle('atingida', nivel >= 2);

      /* Um instante antes de mexer, para o browser animar a largura. */
      requestAnimationFrame(() => {
        if (risco) risco.style.width = porCento + '%';
      });
    }

    /*
     * O formato do tema esta preso a moeda da loja: quem escolhia libras via a
     * conta certa mas com o simbolo do euro a frente. Quem manda e a moeda que
     * o cliente tem escolhida, e o proprio navegador sabe formata-la.
     */
    dinheiro(centimos) {
      const moeda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      const lingua =
        (window.Shopify && Shopify.locale) || document.documentElement.lang || 'pt-PT';
      try {
        return new Intl.NumberFormat(lingua, {
          style: 'currency',
          currency: moeda,
          minimumFractionDigits: 2
        }).format(centimos / 100);
      } catch (e) {
        const formato =
          (window.theme && window.theme.settings && window.theme.settings.money_format) ||
          '€{{amount_with_comma_separator}}';
        return typeof formatMoney === 'function'
          ? formatMoney(centimos, formato)
          : (centimos / 100).toFixed(2);
      }
    }

    montaFrase(modelo, centimos) {
      if (!modelo) return '';
      /* O Liquid entrega a frase com um @@ no lugar do dinheiro: assim a ordem
         das palavras fica a cargo de cada lingua. */
      return modelo.replace('@@', this.dinheiro(centimos));
    }
  }

  customElements.define('mvn-desconto', MvnDesconto);
}


/* ------------------------------------------------------------------ */
/* O «menos» na quantidade 1 tira a camisola do carrinho               */
/* ------------------------------------------------------------------ */
/*
 * O selector de quantidade do tema tem min="1" e nunca desce a zero: quem
 * carregava no menos com uma camisola so ficava preso, sem perceber que tinha
 * de ir ao caixote do lixo. Apanhamos o clique antes do tema (fase de captura)
 * e, se ja esta em 1, pomos o campo a zero e damos o mesmo aviso que o tema
 * espera — dai para a frente e ele que remove a linha, na gaveta ou na pagina
 * do carrinho.
 */
if (!window.__mvnMenosLigado) {
  window.__mvnMenosLigado = true;
  document.addEventListener(
    'click',
    (e) => {
      const botao = e.target.closest && e.target.closest('quantity-selector .minus');
      if (!botao) return;
      const caixa = botao.closest('quantity-selector');
      const campo = caixa && caixa.querySelector('.qty');
      if (!campo || Number(campo.value) > 1) return;

      e.preventDefault();
      campo.value = 0;
      campo.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );
}

/* ------------------------------------------------------------------ */
/* Fazer deslizar a caixa das sugestoes                                */
/* ------------------------------------------------------------------ */
/*
 * No computador a caixa das sugestoes vive escondida atras da gaveta e so
 * aparece quando alguem lhe poe a classe `active`. O tema fazia isso quando
 * era ele a construir as recomendacoes; como as nossas sugestoes sao feitas em
 * Liquid, ha caminhos de abertura em que ninguem a chama. Tratamos disso aqui,
 * sempre que a gaveta abre.
 */
if (!window.__mvnSugestoesLigado) {
  window.__mvnSugestoesLigado = true;

  const mostra = () => {
    const gaveta = document.getElementById('Cart-Drawer');
    if (!gaveta || !gaveta.classList.contains('active')) return;
    const caixa = gaveta.querySelector('.product-recommendations--full');
    if (caixa) caixa.classList.add('active');
  };

  document.addEventListener('cart-drawer:open', () => setTimeout(mostra, 60));

  const gaveta = document.getElementById('Cart-Drawer');
  if (gaveta) {
    new MutationObserver(() => setTimeout(mostra, 60)).observe(gaveta, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: false
    });
  }
}

/* ------------------------------------------------------------------ */
/* Sugestoes: escolher e personalizar sem sair do carrinho (27/09)     */
/* ------------------------------------------------------------------ */
/*
 * Os cartoes vem de snippets/mvn-sugestoes.liquid com os dados num JSON ao lado.
 * A gaveta e redesenhada com innerHTML (os <script> la dentro nao correm), por isso
 * tudo aqui vai por delegacao no documento.
 * A variante escolhe-se pela POSICAO de cada valor, nunca pelo texto (traduz-se):
 *   3 opcoes = tamanho / emblema (0 sem, 1 com) / nome (0 nenhum, 1 jogador, 2 a escolha)
 *   2 opcoes = tamanho / nome.
 * As linhas da encomenda sao as mesmas da pagina do produto: Badges, Player, Name,
 * Number; e nas de crianca com kit irmao a «so camisola / camisola + calcoes».
 */
if (!window.__mvnSgLigado) {
  window.__mvnSgLigado = true;
  const est = { d: null, tam: -1, kit: 0, emb: -1, nn: 0, pl: '', nome: '', num: '' };

  const idx = (lista, val) => (val == null ? 0 : Math.max(0, lista.indexOf(val)));
  const nOpc = (d) => (d.o || []).length;
  const iEmb = (d) => (nOpc(d) >= 3 ? 1 : -1);
  const iNome = (d) => (nOpc(d) >= 3 ? 2 : nOpc(d) === 2 ? 1 : -1);
  const alvo = () => (est.kit === 1 && est.d.k ? est.d.k : est.d);
  const querido = (d, tam) => {
    const q = [tam, 0, 0];
    if (iEmb(d) > 0) q[iEmb(d)] = est.emb >= 0 ? 1 : 0;
    if (iNome(d) > 0) q[iNome(d)] = est.nn;
    return q;
  };
  const variante = (d, tam, q) => {
    q = q || querido(d, tam);
    for (const v of d.v) {
      const pos = [idx(d.o[0] || [], v[1]), idx(d.o[1] || [], v[2]), idx(d.o[2] || [], v[3])];
      if (pos[0] === q[0] && pos[1] === q[1] && pos[2] === q[2]) return v;
    }
    return null;
  };
  /* A caixinha abre como folha por cima de tudo (de baixo no telemovel, a direita no
     computador). Vive no <body>: dentro da gaveta ficava presa a coluna estreita e a
     gaveta, ao ser redesenhada, levava-a. O molde vem escondido no snippet. */
  const fecha = () => {
    const f = document.getElementById('mvn-sg-folha');
    if (f) f.hidden = true;
    document.documentElement.classList.remove('mvn-sg-aberta');
    est.d = null;
    document.querySelectorAll('.mvn-sg__c.is-sel').forEach((c) => c.classList.remove('is-sel'));
  };
  const folha = (caixa) => {
    let f = document.getElementById('mvn-sg-folha');
    const molde = caixa.querySelector('.mvn-sg__painel');
    if (!f) {
      f = molde.cloneNode(true);
      f.id = 'mvn-sg-folha';
      document.body.appendChild(f);
      const fundo = document.createElement('div');
      fundo.className = 'mvn-sg__fundo';
      fundo.addEventListener('click', fecha);
      document.body.appendChild(fundo);
    } else if (molde) {
      Object.assign(f.dataset, molde.dataset);
    }
    document.documentElement.classList.add('mvn-sg-aberta');
    return f;
  };
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && est.d) fecha(); });
  const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };

  const valido = () => {
    const a = alvo();
    if (est.tam < 0) return false;
    const v = variante(a, est.tam);
    if (!v || !v[4]) return false;
    if (iNome(a) > 0 && est.nn === 1 && !est.pl) return false;
    if (iNome(a) > 0 && est.nn === 2 && !est.nome.trim()) return false;
    return true;
  };

  const desenha = (painel, soBotao) => {
    const d = est.d, a = alvo(), T = painel.dataset;
    const ok = painel.querySelector('.mvn-sg__ok');
    const v = est.tam >= 0 ? variante(a, est.tam) : null;
    ok.disabled = !valido();
    ok.textContent = T.carr + (v && v[5] ? ' · ' + v[5] : '');
    if (soBotao) return;

    painel.querySelector('.mvn-sg__pt').textContent = d.t;
    const kit = painel.querySelector('.mvn-sg__kit');
    kit.hidden = !d.k;
    if (d.k) kit.querySelectorAll('button').forEach((b) => {
      b.textContent = d.kl[+b.dataset.k];
      b.classList.toggle('is-on', +b.dataset.k === est.kit);
    });

    const tams = painel.querySelector('.mvn-sg__tams');
    tams.innerHTML = '';
    (a.o[0] || []).forEach((nome, i) => {
      const b = el('button', null, nome);
      b.type = 'button'; b.dataset.t = i;
      const w = variante(a, i, [i, 0, 0]);
      if (!w || !w[4]) b.disabled = true;
      if (i === est.tam && !b.disabled) b.classList.add('is-on');
      tams.appendChild(b);
    });

    const emb = painel.querySelector('.mvn-sg__emb');
    emb.innerHTML = '';
    emb.hidden = !(iEmb(a) > 0 && d.b && d.b.length);
    if (!emb.hidden) {
      emb.appendChild(el('p', 'mvn-sg__rot', T.tEmblema));
      const fila = el('div', 'mvn-sg__embs');
      const sem = el('button', 'mvn-sg__e0' + (est.emb < 0 ? ' is-on' : ''), T.tSem);
      sem.type = 'button'; sem.dataset.e = -1; fila.appendChild(sem);
      d.b.forEach((b, i) => {
        const bt = el('button', 'mvn-sg__e' + (est.emb === i ? ' is-on' : ''));
        bt.type = 'button'; bt.dataset.e = i; bt.title = b.n;
        const im = el('img'); im.src = b.f; im.alt = b.n; im.width = 34; im.height = 34; im.loading = 'lazy';
        bt.appendChild(im); bt.appendChild(el('span', null, b.n));
        fila.appendChild(bt);
      });
      emb.appendChild(fila);
    }

    const nn = painel.querySelector('.mvn-sg__nn');
    nn.innerHTML = '';
    const io = iNome(a);
    nn.hidden = !(io > 0);
    if (!nn.hidden) {
      nn.appendChild(el('p', 'mvn-sg__rot', (a.on && a.on[io]) || T.tNome));
      const fila = el('div', 'mvn-sg__nns');
      (a.o[io] || []).forEach((nome, i) => {
        if (i === 1 && !(d.pl && d.pl.length)) return;
        const b = el('button', est.nn === i ? 'is-on' : '', nome);
        b.type = 'button'; b.dataset.n = i; fila.appendChild(b);
      });
      nn.appendChild(fila);
      if (est.nn === 1 && d.pl) {
        const sel = el('select', 'mvn-sg__pl');
        sel.appendChild(el('option', null, T.tJogador + '…')).value = '';
        d.pl.forEach((p) => { const o = el('option', null, p); o.value = p; if (p === est.pl) o.selected = true; sel.appendChild(o); });
        nn.appendChild(sel);
      }
      if (est.nn === 2) {
        const f = el('div', 'mvn-sg__campos');
        const iN = el('input', 'mvn-sg__nome'); iN.type = 'text'; iN.maxLength = 15; iN.placeholder = T.tPh; iN.value = est.nome; iN.autocomplete = 'off';
        const iM = el('input', 'mvn-sg__num'); iM.type = 'text'; iM.maxLength = 2; iM.inputMode = 'numeric'; iM.placeholder = '00'; iM.value = est.num; iM.autocomplete = 'off';
        f.appendChild(iN); f.appendChild(iM); nn.appendChild(f);
      }
    }
    desenha(painel, true);
  };

  document.addEventListener('input', (e) => {
    const painel = e.target.closest && e.target.closest('.mvn-sg__painel');
    if (!painel || !est.d) return;
    if (e.target.matches('.mvn-sg__nome')) est.nome = e.target.value.toUpperCase().replace(/[^A-ZÀ-Ý .'\-]/g, '').slice(0, 15), (e.target.value = est.nome);
    if (e.target.matches('.mvn-sg__num')) est.num = e.target.value.replace(/\D/g, '').slice(0, 2), (e.target.value = est.num);
    desenha(painel, true);
  });
  document.addEventListener('change', (e) => {
    const painel = e.target.closest && e.target.closest('.mvn-sg__painel');
    if (!painel || !est.d) return;
    if (e.target.matches('.mvn-sg__pl')) { est.pl = e.target.value; desenha(painel, true); }
  });

  document.addEventListener('click', (e) => {
    const t = e.target;
    const add = t.closest && t.closest('.mvn-sg__add');
    if (add) {
      e.preventDefault();
      const cartao = add.closest('.mvn-sg__c');
      const caixa = add.closest('.mvn-sg');
      const painel = folha(caixa);
      caixa.querySelectorAll('.mvn-sg__c.is-sel').forEach((c) => c.classList.remove('is-sel'));
      cartao.classList.add('is-sel');
      try { est.d = JSON.parse(cartao.querySelector('.mvn-sg__dados').textContent); } catch (err) { window.location = cartao.dataset.url; return; }
      Object.assign(est, { tam: -1, kit: 0, emb: -1, nn: 0, pl: '', nome: '', num: '' });
      const livres = (est.d.o[0] || []).filter((n, i) => { const v = variante(est.d, i, [i, 0, 0]); return v && v[4]; });
      if (livres.length === 1) est.tam = (est.d.o[0] || []).indexOf(livres[0]);
      painel.hidden = false;
      desenha(painel);
      return;
    }
    const painel = t.closest && t.closest('.mvn-sg__painel');
    if (!painel || !est.d) return;
    if (t.closest('.mvn-sg__x')) { fecha(); return; }
    const bt = t.closest('.mvn-sg__tams button');
    if (bt && !bt.disabled) { est.tam = +bt.dataset.t; desenha(painel); return; }
    const bk = t.closest('.mvn-sg__kit button');
    if (bk) { est.kit = +bk.dataset.k; desenha(painel); return; }
    const be = t.closest('.mvn-sg__embs button');
    if (be) { est.emb = +be.dataset.e; desenha(painel); return; }
    const bn = t.closest('.mvn-sg__nns button');
    if (bn) { est.nn = +bn.dataset.n; desenha(painel); return; }
    const ok = t.closest('.mvn-sg__ok');
    if (ok && !ok.disabled && valido()) {
      const a = alvo();
      const v = variante(a, est.tam);
      if (!v) return;
      const props = {};
      if (est.d.k) props[est.d.ko] = est.d.kl[est.kit];
      if (iEmb(a) > 0 && est.emb >= 0 && est.d.b) props.Badges = est.d.b[est.emb].n;
      if (iNome(a) > 0 && est.nn === 1) props.Player = est.pl;
      if (iNome(a) > 0 && est.nn === 2) { props.Name = est.nome.trim(); if (est.num) props.Number = est.num; }
      const item = { id: v[0], quantity: 1 };
      if (Object.keys(props).length) item.properties = props;
      ok.disabled = true;
      ok.classList.add('is-loading');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then((r) => r.json())
        .then((r) => {
          ok.classList.remove('is-loading');
          if (r.status) { ok.textContent = r.description || r.message || 'Error'; ok.disabled = false; return; }
          ok.textContent = painel.dataset.ok;
          setTimeout(fecha, 500);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => {
            const g = document.getElementById('Cart-Drawer');
            const c = g && g.querySelector('.product-recommendations--full');
            if (c) c.classList.add('active');
          }, 900);
        })
        .catch(() => { ok.classList.remove('is-loading'); ok.disabled = false; });
    }
  });
}
